import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GridModule } from '@ui/grid/grid.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { initTheme } from './initializers/theme.initialiser';
import { ThemeState } from '@shared/states/theme.state';
import { AppInjector } from '@shared/config/app-injector';
import { CommonModule } from '@angular/common';
import { ToastModule } from '@ui/toast/toast.module';
import { MainHeaderModule } from '@ui/main-header/main-header.module';
import { MainSidebarModule } from '@ui/main-sidebar/main-sidebar.module';
import { NoFoundComponent } from './no-found/no-found.component';
import { SvgModule } from '@ui/svg/svg.module';
import { ButtonModule } from '@ui/button/button.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { initSentryClient } from '@shared/sentry/sentry.browser';

export function initSentry(): () => void {
  return () => initSentryClient();
}

@NgModule({
  declarations: [AppComponent, NoFoundComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initTheme,
      multi: true,
      deps: [ThemeState],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initSentry,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    GridModule,
    BrowserAnimationsModule,
    ToastModule,
    MainHeaderModule,
    MainSidebarModule,
    SvgModule,
    ButtonModule,
    DirectivesModule,
    PipesModule,
  ],
})
export class AppModule {
  constructor(private injector: Injector) {
    AppInjector.Injector = injector;
  }
}
